// src/Context/WalletContext.js
import { createContext, useContext } from "react";
import useWalletBalance from "../Hooks/Wallet/useWalletBalance";
import { useAuth } from "./AuthContext";

const WalletContext = createContext();

export const useWallet = () => {
  const context = useContext(WalletContext);
  if (!context) {
    throw new Error("useWallet must be used within a WalletProvider");
  }
  return context;
};

export const WalletProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();

  // ✅ اجلب الرصيد فقط إذا كان المستخدم مسجل دخول
  const wallet = useWalletBalance({ enabled: isAuthenticated });

  return (
    <WalletContext.Provider value={wallet}>
      {children}
    </WalletContext.Provider>
  );
};
